import React, {useState} from 'react'

// material
import { Button, Card, CardContent, Grid, TextField, withStyles} from '@material-ui/core';
// styles
import styles from './personal-info-card-styles';

const PersonalInfoCardEdit = (props)=> {
  const {
    classes,
    isLoading,
    userDetails,
  } = props;

  const [fName, setfName] = useState(userDetails.firstName === null ? '' : userDetails.firstName);
  const [lName, setlName] = useState(userDetails.lastName === null ? '' : userDetails.lastName);
  const [phone, setPhone] = useState(userDetails.phoneNumber === null ? '' : userDetails.phoneNumber);

  const submitNewUserDetails = () => {
    const newUserDetails = {};
    newUserDetails.details = userDetails;
      
    if (userDetails.firstName !== fName)
      newUserDetails.details.firstName = fName;
    
    if (userDetails.lastName !== lName)
      newUserDetails.details.lastName = lName;
    
    if (userDetails.phoneNumber !== phone)
      newUserDetails.details.phoneNumber = phone;

    props.setUserDetails(newUserDetails)
  };
  
  return (
    <Card>
      <CardContent>
        <Grid container className={classes.displayTitle} spacing={2}>
          <Grid item>Personal Info</Grid>
        </Grid>
        {
          !isLoading &&
          <Grid container className={classes.displayBody} spacing={2}>
            <Grid item xs={12} sm={7}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <TextField
                    fullWidth
                    label={'First Name'}
                    value={fName}
                    name={'FirstName'}
                    onChange={e => setfName(e.target.value)}
                    variant={'outlined'}/>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    fullWidth
                    label={'Last Name'}
                    value={lName}
                    name={'LastName'}
                    onChange={e => setlName(e.target.value)}
                    variant={'outlined'}/>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    fullWidth
                    label={'Phone'}
                    value={phone}
                    name={'Phone'}
                    onChange={e => setPhone(e.target.value)}
                    variant={'outlined'}/>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Grid 
                container 
                spacing={2}>
                <Grid item>
                  <Button color={'primary'} size={'small'} variant={'contained'} onClick={() => submitNewUserDetails()}>Save</Button>
                </Grid>
                <Grid item>
                  <Button color={'primary'} size={'small'} onClick={() => props.toggleEdit()}>Cancel</Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        }
      </CardContent>
    </Card>
  )
};

export default withStyles(styles) (PersonalInfoCardEdit);